import { Modal } from '@components/base';
import { Button } from '@components/base';
import css from './index.module.scss';
import { Typography } from '@components/base';
import { useCallback } from 'react';

interface ISaveToDraftProps {
  open: boolean;
  onClose: () => void;
  onConfirm?: (data: any) => void;
  message?: string;
  onSaveAsDraft?: () => Promise<void>;
  confirmText?: string;
  cancelText?: string;
  saveAsDraftText?: string;
}

function SaveToDraftPrompt(props: ISaveToDraftProps) {
  const {
    open,
    onClose,
    onConfirm,
    message = 'Are you sure you want to delete this item?',
    confirmText = 'Leave',
    cancelText = 'Stay',
    saveAsDraftText = 'Save as Draft Instead'
  } = props;

  const handleConfirm = useCallback(() => {
    if (onConfirm) {
      onConfirm({});
    }
    onClose();
  }, [onConfirm, onClose]);

  const modalWrapperClass = props.onSaveAsDraft
    ? `${css.modalWrapper} ${css.withSaveAsDraft}`
    : css.modalWrapper;

  return (
    <Modal open={open} onClose={onClose}>
      <div className={modalWrapperClass}>
        <Typography variant="body">{message}</Typography>
        <div className={css.buttonWrapper}>
          <Button
            variant="outlined-secondary"
            color="primary"
            onClick={onClose}
            className={css.saveAsDraftButton}
          >
            {cancelText}
          </Button>
          {props.onSaveAsDraft && (
            <Button
              variant="text"
              color="primary"
              onClick={props.onSaveAsDraft}
              className={css.saveAsDraftButton}
            >
              {saveAsDraftText}
            </Button>
          )}
          <Button variant={'contained'} color="secondary" onClick={handleConfirm}>
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default SaveToDraftPrompt;
